export default __webpack_public_path__ + "static/media/question-icon-uncolored.9b4f35bc.svg";